import { render, staticRenderFns } from "./CodePasswordForm.vue?vue&type=template&id=cf3b2896&"
import script from "./CodePasswordForm.vue?vue&type=script&lang=ts&"
export * from "./CodePasswordForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports